/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-29 15:23:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-29 15:24:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/currency',
    name: getI18n('storeCurrency.detail.currency'),
  },
];
